import moment from 'moment';

import templateUrl from './edit-product-commission-policy.component.html';

export const EditProductCommissionPolicyComponent = {
    require: {
        editForm: "^^form"
    },
    controller: EditProductCommissionPolicyController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        productCommissionPolicy: "<",
        products: "<",
        productLines: "<",
        autoProductLine: "<",
        onSave: "&",
        onDelete: "&",
        onValidate: "&",
        onEditOtherPolicy: "&"
    }
};

function EditProductCommissionPolicyController(productCommissionPolicyArchiveService) {
    'ngInject';
    const vm = this;

    vm.autoProductLine;
    vm.productCommissionPolicy;
    vm.products;
    vm.productLines;
    vm.onDelete;
    vm.onValidate;
    vm.onEditOtherPolicy;
    vm.filterArchive = filterArchive;
    vm.filterVisibleArchive = filterVisibleArchive;
    vm.onAddArchive = onAddArchive;
    vm.onDeleteArchive = onDeleteArchive;
    vm.onArchiveChange = onArchiveChange;
    vm.onChangeProduct = onChangeProduct;
    vm.filteredProductLines;

    function filterArchive(archive) {
        return !archive.IsDeleted;
    }

    function filterVisibleArchive(archive) {
        return !archive.IsNew || !archive.IsDeleted;
    }

    function onAddArchive() {
        const newArchive = productCommissionPolicyArchiveService.addArchive(vm.productCommissionPolicy);
        newArchive.isOpen = true;
        vm.editForm.$setDirty(true);
    }

    function onDeleteArchive(archive) {
        productCommissionPolicyArchiveService.deleteArchive(archive, function () {
            return confirm("The policy will be deleted after you click save.");
        });
        onArchiveChange(archive);
    }

    function onArchiveChange(archive) {

        if (archive.ActiveInstalledEnd && archive.ActiveInstalledStart) {
            archive.editForm.$setValidity("dateComparision", !(moment(archive.ActiveInstalledEnd) < moment(archive.ActiveInstalledStart)));
        }
        if (archive.ActiveOrderEnd && archive.ActiveOrderStart) {
            archive.editForm.$setValidity("The start date should be greater than end date", !(moment(archive.ActiveOrderEnd) < moment(archive.ActiveOrderStart)));
        }

        const isValidPattern = productCommissionPolicyArchiveService.isValidPolicyPattern(vm.productCommissionPolicy);
        vm.productCommissionPolicy.IsInvalidPattern = !isValidPattern;
        vm.editForm.$setValidity("patternNotValid", isValidPattern);

        vm.productCommissionPolicy.Archives.filter(function (archive) {
            return !archive.IsDeleted;
        }).forEach(function (archive) {

            const hasConflicts = productCommissionPolicyArchiveService.archiveDatesOverlap(archive,
                archive.ActiveInstalledStart, archive.ActiveInstalledEnd, archive.ActiveOrderStart,
                archive.ActiveOrderEnd, vm.productCommissionPolicy);
            archive.editForm.$setValidity("conflict", !hasConflicts);
            if (archive.ActiveInstalledStart || archive.ActiveOrderStart) {
                const changes = productCommissionPolicyArchiveService.updateProductCommissionPolicyArchive(
                    vm.productCommissionPolicy, archive);

                changes.forEach(function (changedArchive) {
                    changedArchive.editForm.$setDirty(true);
                });
            }
        });
        vm.productCommissionPolicy.errorModelState = null;
        vm.productCommissionPolicy.Archives.sort(function (a, b) {
            if (a.ActiveOrderStart < b.ActiveOrderStart) {
                return 1;
            } else if (a.ActiveOrderStart > b.ActiveOrderStart) {
                return -1;
            } else {
                if (a.ActiveInstalledStart < b.ActiveInstalledStart) {
                    return 1;
                } else if (a.ActiveInstalledStart > b.ActiveInstalledStart) {
                    return -1;
                } else {
                    return 0;
                }
            }
        })[0];
        archive.editForm.$setDirty(true);
    }

    function onChangeProduct() {
        if (vm.productCommissionPolicy.Product) {
            vm.productCommissionPolicy.ProductID = vm.productCommissionPolicy.Product.ProductID;
            vm.filteredProductLines = vm.productLines.filter(function (event) {
                return event.DivisionID === vm.productCommissionPolicy.Product.DivisionID
            });

            const excludedSelectedCategory = vm.filteredProductLines.filter(function (event) {
                return event.CategoryID !== vm.productCommissionPolicy.Product.CategoryID
            }).sort((a, b) => a.Name < b.Name ? -1 : 1);

            vm.filteredProductLines = vm.filteredProductLines.filter((event) =>
                event.CategoryID === vm.productCommissionPolicy.Product.CategoryID
            ).sort((a, b) => a.Name < b.Name ? -1 : 1);

            excludedSelectedCategory.forEach(element => {
                return vm.filteredProductLines.push(element);
            });
            if (vm.autoProductLine) {
                selectAutoProductLine();
            }
        }
        vm.onValidate();
    }


    function selectAutoProductLine() {
        let productLine;
        if (vm.autoProductLine === true) {
            productLine = vm.filteredProductLines.filter(function (line) {
                return line.ProductLineID === vm.productCommissionPolicy.Product.ProductLineID;
            })[0];
        } else if (vm.autoProductLine) {
            // Not a boolean, but still a truthy value was passed in. Treat it as the name of the auto product line.
            productLine = vm.filteredProductLines.filter(function (line) {
                return line.ProductLineCode === vm.autoProductLine;
            })[0];
        }

        // Propagate changes the the product line.
        if (productLine) {
            vm.productCommissionPolicy.ProductLine = productLine;
            vm.productCommissionPolicy.ProductLineID = productLine.ProductLineID;
        } else {
            vm.productCommissionPolicy.ProductLine = null;
            vm.productCommissionPolicy.ProductLineID = null;
        }
    }
}
